import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const HexagonIcon = ({
  width = "12",
  height = "12",
  color = "#0860A8",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.40078 10.5L0.800781 6L3.40078 1.5H8.60078L11.2008 6L8.60078 10.5H3.40078Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
